import * as _ from 'lodash';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import type { VoidFunctionComponent } from 'react';

import { useDispatchOnMount } from '../../../hooks';
import OrganizationStore from '../../../redux/organizations';
import {
  CheckboxMenuItem,
  FocusableItem,
  Icon,
  icons,
  Menu,
  MenuDivider,
  MenuGroup,
  SearchInput,
} from '../../generic';
import Button from '../../generic/Button';
import type { SnapshotFilters } from '../../../../shared/issuesV2/snapshots';

type Props = {
  filters: SnapshotFilters;
  setLabels: (labels: number[]) => void;
  isDisabled?: boolean;
};

/**
 * Dropdown menu for filtering by Label on the Issue Overview page.
 */
const LabelFilter: VoidFunctionComponent<Props> = ({ filters, setLabels, isDisabled }) => {
  const [search, setSearch] = useState('');
  const orgLabels = useSelector(OrganizationStore.selectors.getSortedOrganizationLabels);

  useDispatchOnMount(OrganizationStore.actions.fetchOrgLabels);

  const labelsToDisplay = orgLabels.filter((label) => label.label.includes(search));

  return (
    <Menu
      menuButton={
        <Button type="secondary" onClick={_.noop} isDisabled={isDisabled}>
          Labels {!!filters.labels?.length && `(${filters.labels.length})`} <Icon icon={icons.chevronDown} />
        </Button>
      }
      direction="bottom"
    >
      <FocusableItem>
        {({ ref }) => (
          <SearchInput ref={ref} onChange={(e) => setSearch(e)} value={search} label="Label search input" />
        )}
      </FocusableItem>
      <MenuDivider />
      <MenuGroup takeOverflow>
        {labelsToDisplay.map((label) => (
          <CheckboxMenuItem
            checked={filters.labels && filters.labels.includes(label.id)}
            onClick={(e) => {
              if (e.checked) {
                setLabels([...(filters.labels ?? []), label.id]);
                return;
              }

              setLabels((filters.labels ?? []).filter((val) => val !== label.id));
            }}
          >
            {label.label}
          </CheckboxMenuItem>
        ))}
      </MenuGroup>
    </Menu>
  );
};

export default LabelFilter;
